import { useState, useCallback } from 'react';
import {
    fetchProductInfoFromDb,
    fetchProductPriceHistoryFromDb,
} from '../services/productService';
import type { ProductInfo, PriceRow } from '../types';
import { getErrorMessage } from '../utils/errors';

export function useProductDetail() {
    const [product, setProduct] = useState<ProductInfo | null>(null);
    const [prices,  setPrices]  = useState<PriceRow[]>([]);
    const [loading, setLoading] = useState(false);
    const [error,   setError]   = useState<string | null>(null);

    const fetchProductDetail = useCallback(async (
        productId: string,
        storeId?: string | null
    ): Promise<void> => {
        setLoading(true);
        setError(null);
        try {
            const [info, priceHistory] = await Promise.all([
                fetchProductInfoFromDb(productId, storeId),
                storeId && storeId !== 'null'
                    ? fetchProductPriceHistoryFromDb(productId, storeId)
                    : Promise.resolve([]),
            ]);
            setProduct(info);
            setPrices(priceHistory);
        } catch (err) {
            setError(getErrorMessage(err, 'Failed to load product details'));
        } finally {
            setLoading(false);
        }
    }, []);

    return { product, prices, loading, error, fetchProductDetail };
}